import React from "react";
import { useUserRole } from "../../../shared/hooks/useUserRole";
import DoctorDashboard from "./components/DoctorDashboard";
import AccountantDashboard from "./components/AccountantDashboard";
import PharmacistDashboard from "./components/PharmacistDashboard";
import metaData from "../../../config/metaData";
import generateMeta from "../../../shared/services/metadataService";

const Dashboard: React.FC = () => {
  const userRole = useUserRole();
  const meta = generateMeta(metaData.home);

  const renderDashboard = () => {
    switch (userRole) {
      case "accountant":
        return <AccountantDashboard />;
      case "pharmacist":
        return <PharmacistDashboard />;
      case "doctor":
      case "superadmin":
      default:
        return <DoctorDashboard />;
    }
  };

  return (
    <>
      {meta}
      {renderDashboard()}
    </>
  );
};

export default Dashboard;
